import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import YourNotifications from './your-notifications';
import { SimpleLoadingComponent } from '../../utils/apollo';
import updateUserSettingsMutation from '../../mutations/YourNotifications/updateUserSettings';

const query = gql`
  query YourNotifications {
    viewer {
      id
      userSettings {
        repVisits {
          hasOptedOutOfAvailabilityEmails
        }
      }
    }
  }
`;

const graphqlData = graphql(query);
const mutateUpdateUserSettings = graphql(updateUserSettingsMutation, {
  name: 'updateUserSettings',
});
export default SimpleLoadingComponent(graphqlData, mutateUpdateUserSettings)(YourNotifications);
